const NONE: ReadonlySet<string> = new Set<string>();

/**
 * Feature keys (see `@wato/business-types`) whose pages already hold data for this workspace, so the
 * account type never hides them (spec §7 rule 4). Returns an empty set until the data checks land.
 */
export function useFeaturesWithData(_workspaceId: string): ReadonlySet<string> {
  return NONE;
}
